import { JobState } from '@treadinc/horizon-api-spec';

export const pendingJobStates = [JobState.CREATED, JobState.REJECTED];
